import { buildPuntoEntregaReportPdf } from '../punto-entrega-fo-2160/buildPuntoEntregaReportPdf.ts';
import type { BuildPuntoEntregaReportPdfOpts, PuntoEntregaReportPdfDetail } from '../punto-entrega-fo-2160/puntoEntregaReportPdfData.ts';
import { buildRedencionBonoReportPdf } from '../redencion-bono-fo-1775/buildRedencionBonoReportPdf.ts';
import type { RedencionBonoReportPdfInput } from '../redencion-bono-fo-1775/redencionBonoReportPdfData.ts';
import { triggerPdfDownload } from '../infrastructure/foGesrPdfLayout.ts';

/**
 * Stateless factory that delegates FO-GESR PDF builders housed under `modules/shared/report-pdf/`.
 */
export function createReportPdfFactory() {
  return {
    /** FO-GESR-2160 — voucher delivery (delivery points). */
    buildPuntoEntregaFo2160: (detail: PuntoEntregaReportPdfDetail, opts: BuildPuntoEntregaReportPdfOpts) =>
      buildPuntoEntregaReportPdf(detail, opts),

    /** FO-GESR-1775 redemption worksheet. */
    buildRedencionBonoFo1775: (input: RedencionBonoReportPdfInput) => buildRedencionBonoReportPdf(input),

    triggerDownload: triggerPdfDownload,
  } as const;
}

export type { BuildPuntoEntregaReportPdfOpts, PuntoEntregaReportPdfDetail } from '../punto-entrega-fo-2160/puntoEntregaReportPdfData.ts';
export type { RedencionBonoReportPdfInput, RedencionBonoReportPdfRow } from '../redencion-bono-fo-1775/redencionBonoReportPdfData.ts';
